import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  activeFile (params) {
    return request.post(API.EMPLOYEE_DETAIL_FILE + params.id + '/logs', params)
  },
  getDetailFile (params) {
    return request.get(API.EMPLOYEE_DETAIL_FILE + params.id, params)
  },
  getFolder (params) {
    return request.get(API.EMPLOYEE_FOLDER, params)
  },
  detailFolder (params) {
    return request.get(API.EMPLOYEE_FOLDER_DETAIL + params.id, params)
  },
  getTags (params) {
    return request.get(API.EMPLOYEE_TAG, params)
  },
  getAuthor (params) {
    return request.get(API.EMPLOYEE_AUTHOR, params)
  },
  getFolderBranches (params) {
    return request.get(API.EMPLOYEE_FOLDER_DETAIL + params.id + '/branches', params)
  },
  searchFile (params) {
    return request.get(API.EMPLOYEE_FILE, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/employee/folder.js